import { render, staticRenderFns } from "./WaitlistCheck.vue?vue&type=template&id=aff83e8c"
import script from "./WaitlistCheck.vue?vue&type=script&lang=js"
export * from "./WaitlistCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports